import { createContext } from 'react';
export type UserType = 'internalSale' | 'externalClient';

export const UserTypeContext = createContext<UserType>('externalClient');
UserTypeContext.displayName = 'UserTypeContext';
